import { Building2 } from 'lucide-react';
import { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { CompanySettingsPage } from '@/pages/settings';
import { ModeProvider } from '@/providers/ModeProvider';

interface Step1Props {
  companiesAdded: number;
  onCompanyAdded: () => void;
}

export function Step1CompanySetup({ companiesAdded, onCompanyAdded }: Step1Props) {
  const [localCount, setLocalCount] = useState(0);

  const handleCompanyAdded = () => {
    onCompanyAdded();
    setLocalCount((n) => n + 1);
  };

  const count = Math.max(companiesAdded, localCount);

  return (
    <div className="flex flex-col h-full">
      {/* Step header */}
      <div className="flex items-center gap-2 mb-6 shrink-0">
        <Building2 className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-semibold">Company Setup</h2>
        {count > 0 && <Badge variant="secondary">{count} added</Badge>}
      </div>

      {/* Embedded Company Settings */}
      <div className="flex-1 min-h-0 overflow-auto rounded-xl border bg-background">
        <div className="p-1">
          <ModeProvider>
            <CompanySettingsPage isOnboarding onCompanyAdded={handleCompanyAdded} />
          </ModeProvider>
        </div>
      </div>
    </div>
  );
}

// Export count accessor for the wizard footer
export {};
